<template>
  <div class="service-content">
    <div class="container">
      <div class="select-title" v-if="contentList&&contentList.length>0">一站式年会服务内容</div>
    <div class="card-content">
          <div v-for="(item,index) in contentList" :key="index" class="card-content-item">
            <img :src="item.path" />
            <span>{{item.title}}</span>
            <p>{{item.description}}</p>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { handlePicPlusPre} from "@/util/util.js";
export default {
  name:"adDetails",
  components: {
    
  },
  props: {},
  data() {
    return {
      id: null,
      message: {},
      isShowPicTxt:-1,
      contentList:[],
      isShowPicTxtleft:0,
    };
  },
  watch: {},
  computed: {
    // 获取站点城市id
    getLocationSiteCityId() {
      return this.$store.state.locationSiteCity?this.$store.state.locationSiteCity:5;
    },
  },
  methods: {
    handlePicPlusPre,
    showPicTxt(index) {
      this.isShowPicTxt = index;
      this.isShowPicTxtleft = 25 *index+1 +"%";
    },
    hidePicTxt() {
      this.isShowPicTxt = -1;
    },
    getContentList(){
      const params = {
        positionId:10,
        cityId:this.getLocationSiteCityId
      }
      axios
        .get(`/api/adm/list`, {
          params
        })
        .then((res) => {
          console.log(res)
          if(res.data &&res.data.code == 200){
              this.contentList = res.data.adList;
            if(this.contentList){
              this.contentList.forEach(banner=>{
                banner.path =  handlePicPlusPre(banner.path);
              })
            }
          }
        })
    }
  },
  created() {
    this.getContentList();
  },
  mounted() {
  }
};
</script>
<style scoped>
.service-content{
  height: 100%;
  width: 100%;
  background: #f5f5f5;
  position: relative;
}

.service-content .container {
  width: 1060px;
}
.service-content .container .select-title{
    font-family: PingFangSC-Regular;
    font-size: 38px;
    color: #201f1f;
    text-align: center;
    padding-top: 40px;
    padding-bottom: 30px;
}
.container .card-content{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  
}
.container .card-content-item{
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-sizing: border-box;
}
.card-content-item img{
    width: 240px;
    border-radius: 4px;
    height: 240px;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;
}
.card-content-item span{
    text-align: center;
    display: block;
    font-size: 20px;
    color: #222;
    font-weight: 700;
    line-height: 40px;
    height: 40px;
    padding-top: 10px;
}
.card-content-item p{
    text-align: center;
    font-size: 14px;
    color: #222;
    padding-top: 16px;
    margin-bottom: 20px;
}

</style>


// WEBPACK FOOTER //
// src/components/annualMeeting/serviceContent.vue